module.exports = __webpack_public_path__ + "static/disease_spanish-8acb991b93f16e8ad689eb05e465f676.png";